(function () {
	const SLIDE_EASING = "cubic-bezier(0.37, 0, 0.63, 1)"; // ~ legacy "swing" easing
	const slideAnimations = new WeakMap();

	const isHidden = (el) => window.getComputedStyle(el).display === "none";

	// Equivalent of legacy .stop(): halt a running slide at its current height.
	const stopSlide = (el) => {
		const running = slideAnimations.get(el);
		if (!running) return null;
		const currentHeight = el.getBoundingClientRect().height;
		running.onfinish = null;
		running.cancel();
		slideAnimations.delete(el);
		return currentHeight;
	};

	const slideDown = (el, duration) => {
		const stoppedHeight = stopSlide(el);
		const wasHidden = isHidden(el);
		if (!wasHidden && stoppedHeight === null) return;
		if (wasHidden) {
			el.style.display = "";
			if (isHidden(el)) el.style.display = "block";
		}
		const styles = window.getComputedStyle(el);
		const startHeight = wasHidden ? 0 : stoppedHeight;
		const animation = el.animate(
			[
				{
					boxSizing: "border-box",
					overflow: "hidden",
					height: `${startHeight}px`,
					paddingTop: startHeight === 0 ? "0px" : styles.paddingTop,
					paddingBottom: startHeight === 0 ? "0px" : styles.paddingBottom,
				},
				{
					boxSizing: "border-box",
					overflow: "hidden",
					height: `${el.offsetHeight}px`,
					paddingTop: styles.paddingTop,
					paddingBottom: styles.paddingBottom,
				},
			],
			{ duration, easing: SLIDE_EASING }
		);
		slideAnimations.set(el, animation);
		animation.onfinish = () => slideAnimations.delete(el);
	};

	const slideUp = (el, duration) => {
		const stoppedHeight = stopSlide(el);
		if (isHidden(el)) return;
		const styles = window.getComputedStyle(el);
		const startHeight = stoppedHeight === null ? el.offsetHeight : stoppedHeight;
		const animation = el.animate(
			[
				{
					boxSizing: "border-box",
					overflow: "hidden",
					height: `${startHeight}px`,
					paddingTop: styles.paddingTop,
					paddingBottom: styles.paddingBottom,
				},
				{
					boxSizing: "border-box",
					overflow: "hidden",
					height: "0px",
					paddingTop: "0px",
					paddingBottom: "0px",
				},
			],
			{ duration, easing: SLIDE_EASING }
		);
		slideAnimations.set(el, animation);
		animation.onfinish = () => {
			slideAnimations.delete(el);
			el.style.display = "none";
		};
	};

	const siblingsMatching = (el, selector) =>
		Array.from(el.parentElement ? el.parentElement.children : []).filter(
			(sibling) => sibling !== el && sibling.matches(selector)
		);

	const initProductAccordion = () => {
		document.querySelectorAll(".about__accordion-toggle").forEach((toggle) => {
			if (toggle.dataset.accordionBound) return;
			toggle.dataset.accordionBound = "true";

			toggle.addEventListener("click", function () {
				const descriptions = siblingsMatching(
					this,
					".about__accordion-description"
				);
				if (!this.classList.contains("active")) {
					this.classList.add("active");
					// legacy .index(): position of the toggle among its parent's children
					const index = Array.prototype.indexOf.call(
						this.parentElement.children,
						this
					);
					if (descriptions[index]) slideDown(descriptions[index], 300);
				} else {
					this.classList.remove("active");
					descriptions.forEach((description) => slideUp(description, 300));
				}
			});
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		if (!imagesWrapper) return;
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			if (el.dataset.zoomBound) return;
			el.dataset.zoomBound = "true";
			el.addEventListener("click", () => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	// Sticky add-to-cart bar: shown between the second section and the footer.
	let revealElements = null;
	let revealTicking = false;

	const getOffset = (element) => {
		const rect = element.getBoundingClientRect();
		return rect.top + window.scrollY;
	};

	const updateRevealPopup = () => {
		revealTicking = false;
		if (!revealElements) return;
		const { stickyBar, secondSection, footer } = revealElements;

		const secondSectionMid = getOffset(secondSection);
		const footerTop = getOffset(footer);
		const scrollPosition = window.scrollY + window.innerHeight;
		const activeOffset =
			window.scrollY > secondSectionMid && scrollPosition < footerTop;

		stickyBar.classList.toggle("active", activeOffset);
	};

	const onRevealScroll = () => {
		if (revealTicking) return;
		revealTicking = true;
		window.requestAnimationFrame(updateRevealPopup);
	};

	const initRevealPopup = () => {
		const stickyBar = document.querySelector(".product__popup"); // Sticky bar
		const secondSection = document.querySelector(".product-section + section"); // Second section
		const footer = document.querySelector("footer"); // Footer

		// Optional feature: bail out (and stop listening) when elements are absent.
		if (!stickyBar || !secondSection || !footer) {
			revealElements = null;
			document.removeEventListener("scroll", onRevealScroll);
			return;
		}

		revealElements = { stickyBar, secondSection, footer };
		document.addEventListener("scroll", onRevealScroll, { passive: true });

		// Initial check in case the user starts in the middle of the page
		updateRevealPopup();
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		initRevealPopup();
	});

	initProductAccordion();
	initZoomImage();
	initRevealPopup();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		const url = new URL(this.dataset.productUrl, window.location.origin);
		new URLSearchParams(window.location.search).forEach((value, key) =>
			url.searchParams.set(key, value)
		);
		if (this.dataset.sectionId) {
			url.searchParams.set("section_id", this.dataset.sectionId);
		}

		fetch(url.toString())
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				if (!this.productElement) {
					this.hidePopup();
					return;
				}

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.catch(() => {
				this.hidePopup();
			})
			.finally(() => {
				const selectDropDown = () => {
					document
						.querySelectorAll(".product__popup .product-form__controls--dropdown")
						.forEach((dropdown) => {
							if (dropdown.dataset.dropdownBound) return;
							dropdown.dataset.dropdownBound = "true";

							const elListItems = dropdown.querySelectorAll(
								".dropdown-select ul li"
							);
							const elItems = dropdown.querySelectorAll(".dropdown-select ul");
							const selectedTexts = dropdown.querySelectorAll(
								".dropdown-select .select-label"
							);

							const closeList = () =>
								elItems.forEach((item) => item.classList.remove("active"));

							selectedTexts.forEach((selectedText) => {
								selectedText.addEventListener("click", (e) => {
									elItems.forEach((item) => item.classList.toggle("active"));
									if (elItems[0]?.classList.contains("active")) {
										e.stopPropagation();
										document.addEventListener("click", closeList, {
											once: true,
										});
									}
								});
							});

							elListItems.forEach((listItem) => {
								listItem.addEventListener("click", () => {
									const text = listItem.textContent;
									selectedTexts.forEach((selectedText) => {
										selectedText.querySelectorAll("span").forEach((span) => {
											span.textContent = text;
											span.setAttribute("title", text);
										});
									});
									closeList();
									document.activeElement?.blur();
								});
							});
						});
				};

				selectDropDown();
			});
	}

	hidePopup() {
		const bar = this.closest(".product__popup");
		if (bar) bar.style.display = "none";
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();

		this.productElement
			.querySelectorAll(".shopify-block, .shopify-app-block")
			.forEach((el) => el.remove());

		this.productElement
			.querySelectorAll("modal-dialog")
			.forEach((el) => el.remove());
	}

	showMoreFields() {
		document.querySelectorAll(".js-show-more").forEach((button) => {
			if (button.dataset.showMoreBound) return;
			button.dataset.showMoreBound = "true";
			button.addEventListener("click", (e) => {
				e.preventDefault();
				Array.from(button.parentElement?.children || []).forEach((sibling) => {
					if (sibling === button) return;
					if (sibling.matches("input, label")) sibling.classList.remove("hidden");
				});
				button.remove();
			});
		});
	}
}

customElements.define("floated-form", FloatedForm);
